const rootActionPath = 'core/ButtonBenefits';

export const BUTTON_BENEFITS_VIEW = `${rootActionPath}/VIEW`;
